<template>
    <div>
        <v-offline
            online-class="online"
            offline-class="offline"
            @detected-condition="amIOnline">
            <template v-slot:[onlineSlot] :slot-name="onlineSlot">
                {{ onlineOfflineMsg }}
            </template>
            <template v-slot:[offlineSlot] :slot-name="offlineSlot">
                {{ onlineOfflineMsg }}
            </template>
        </v-offline>
        <div class="row">
            <div class="col-sm-12 col-md-8">
                <h5 class="set_font_title">Manage Communities</h5>
            </div>
            <div v-if="project && project.organisation_id && !isReadOnly" class="col-sm-12 col-md-4 text-right">
                <button class="btn btn-success" @click="showAddCommunityDialog(true)">+ Add Community</button>
            </div>
        </div>
        <div class="card row">
            <div class="card-body col-sm-12 col-xl-12">
                <table id="hcCommunityRecords" class="display" width="100%"></table>
            </div>
        </div>
        <el-dialog  :width="dialogWidth" :fullscreen="isMobile" :title="(model.communityId ? 'Update' : 'Add') + ' Community'" :visible.sync="dialogVisible" @opened="onDialogOpened">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <p class="card-title"><b>(Search for your city/region and then pin it
                                    on the map using your cursor)</b></p>
                            </div>
                            <div>
                                <div class="pac-card" id="pac-card">
                                    <MapBase
                                        ref="mapBase"
                                        :allowPinDrop="true"
                                        :enablePins="true"
                                        :enableSearch="true"
                                        :zoom="15"
                                        :center="mapCenter"
                                        :pins="pins"
                                        @map-clicked="getGeoLocation"
                                        @address-selected="addressSelected"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-sm-12">
                            <p>
                                To load Country, State and Province please select location pin point on Map.
                            </p>
                        </div>
                    </div>
                    <div v-if="!isLocationConfirmed && model.selectedLocation">
                        <p>Is selected Location confirmed?</p>
                        <el-button
                            @click="fetchLocality"
                            :loading="fetchingAddress"
                            type="primary"
                        >
                            Yes
                        </el-button>
                        <el-button
                            @click="enableMapSearch = true;
                            selectedLocation = null;
                            "
                            type="primary"
                            plain
                        >
                            No
                        </el-button>
                    </div>
                    <div v-else class="row">
                        <div class="col-lg-3">
                            <label class="control-label">Country</label>
                            <br/>
                            <fg-input :disabled="fetchingAddress" v-model="model.selectedCountry"
                                      :placeholder="selectCountryLabel"/>
                        </div>
                        <div class="col-lg-3">
                            <label class="control-label">State/Province</label>
                            <br/>
                            <fg-input :disabled="fetchingAddress" v-model="model.selectedState"
                                      :placeholder="selectStateLabel"/>
                        </div>
                        <div class="col-lg-3">
                            <label class="control-label">City/District/Village</label>
                            <br/>
                            <fg-input :disabled="fetchingAddress" v-model="model.selectedLocality"
                                      :placeholder="selectLocalityLabel"/>
                        </div>
                        <div class="col-lg-3">
                            <label class="control-label">Community Name</label>
                            <br/>
                            <fg-input :disabled="fetchingAddress" v-model="model.community"
                                      placeholder="Enter Community Name"/>
                        </div>
    
                        <div class="col-12 text-right mt-3">
                            <el-button native-type="button" class="btn btn-success" :loading="show.actionLoading" @click="saveCommunity">
                                {{ show.actionLoading ? 'Saving' : 'Save' }}
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>

import mixin from '../../../mixins/GlobalMixin';
import communityService from "../../../services/community.service";
import {
  Dialog,
  Button,
  Image,
  Form,
  FormItem,
  Input,
  Select,
} from "element-ui";
import VOffline from 'v-offline';
import { mapGetters } from "vuex";
import MapBase from '../../map/MapBase.vue';
import ReverseGeocodingService from '../../../services/reverse-geocoding.service';
export default {
    components: {
        [Dialog.name]: Dialog,
        [Button.name]: Button,
        [Image.name]: Image,
        [Form.name]: Form,
        [FormItem.name]: FormItem,
        [Input.name]: Input,
        [Select.name]: Select,
        VOffline,
        MapBase
    },
    props: {
        projectId: {
            type: Number,
        },
    },
    data() {
        return {
            fetchingAddress: false,
            selectCountryLabel: 'Country',
            selectStateLabel: 'State',
            selectLocalityLabel: 'Locality',
            mapCenter: {},

            model: {
                selectedCountry: null,
                selectedState: null,
                selectedLocality: null,
                selectedLocation: null,
                community: null,
                communityId: null
            },

            map: null,
            dialogVisible: false,
            project: null,

            show: {
                actionLoading: false
            },
            records: [],
            mapInitialized: false,
            isLocationConfirmed: false,
            pins: [],
            isMobile: false,
            dialogWidth: '60%',
        }
    },
    mixins: [mixin],
    computed: {
        ...mapGetters("user", ["userData"]),
    },
    methods: {
        onDialogOpened() {
            const vm = this;
            vm.pins = [];
            vm.$nextTick(() => {
                const mapRef = vm.$refs.mapBase;
                if (mapRef && mapRef.clearClickMarker) {
                    mapRef.clearClickMarker();
                }
                vm.updateMapCenterAndMarker();
            });
        },

        addressSelected(event) {
            const latLng = {
                lat: event.y,
                lng: event.x
            }
            this.getGeoLocation(latLng);
        },

        getGeoLocation: function (latLng) {
            let vm = this;

            vm.pins = [];
            vm.selectCountryLabel = 'Loading..';
            vm.selectStateLabel = 'Loading...';
            vm.selectLocalityLabel = 'Loading...';

            vm.model.selectedLocation = `${latLng.lat},${latLng.lng}`;
            vm.model.selectedCountry = null;
            vm.model.selectedState = null;
            vm.model.selectedLocality = null;

            vm.fetchLocality();

        },

        updateMapCenterAndMarker() {
            let vm = this;

            if (vm.model.selectedLocation) {
                // Extract latitude and longitude from the selectedLocation
                const location = vm.model.selectedLocation.split(',');
                const latlng = {
                    lat: parseFloat(location[0]),
                    lng: parseFloat(location[1])
                };

                // Center the map on the selected location
                vm.mapCenter = latlng;
                vm.pins = [{ ...latlng }];
            } else if (navigator.geolocation) {
                // Use geolocation to center the map if no location is selected
                navigator.geolocation.getCurrentPosition(function (position) {
                    let pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };

                    vm.mapCenter = pos;
                }, function () {
                    vm.useProjectDefaultLocation();
                });
            } else {
                vm.useProjectDefaultLocation();
            }
        },

        useProjectDefaultLocation() {
            let vm = this;
            vm.project = vm.$store.getters.getCurrentSelectedProject;

            if (vm.project && vm.project.project_location_lat_lng) {
                const [lat, lng] = vm.project.project_location_lat_lng.split(',').map(parseFloat);
                vm.mapCenter = { lat, lng };
                vm.pins = [{ lat, lng }];
            } else {
                console.warn('No project default location available');
            }
        },

        showAddCommunityDialog(isNew = false) {
            const vm = this;
            vm.dialogVisible = true;
            if (isNew) {
                vm.model = {
                    selectedCountry: null,
                    selectedState: null,
                    selectedLocality: null,
                    selectedLocation: null,
                    community: null,
                    communityId: null
                };
                vm.pins = [];
            }
        },

        addCommunity() {
            const vm = this;
            const payload = {
                lat_lng: vm.model.selectedLocation,
                country: vm.model.selectedCountry,
                state: vm.model.selectedState,
                city: vm.model.selectedLocality,
                project_id: vm.projectId,
                added_by: vm.userData.user.id,
                community: vm.model.community
            };
            vm.show.actionLoading = true;
            communityService.addCommunity(vm.projectId, payload)
            .then((apiResponse) => {
                apiResponse = apiResponse.response;
                vm.show.actionLoading = false;
                if (!apiResponse.error.error_code) {
                    vm.dialogVisible = false;
                    vm.showAlert('Success', `New community ${vm.model.community} added`, true);
                    vm.getCommunityList();
                    vm.resetModel();
                } else {
                    vm.showAlert('Error', apiResponse.error.msg, false);
                }
            })
            .catch((error) => {
                vm.show.actionLoading = false;
                vm.showAlert('Error', error.response.error.error_msg, false);
            })
        },

        getCommunityList() {
            let vm = this;
            const loading = this.$loading({
                lock: true,
                text: 'Please wait loading records...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            communityService.getCommunityList(vm.projectId)
            .then((apiResponse) => {
                loading.close();
                vm.records = apiResponse.response.data.communities;
                vm.mapRecordWithTable();
            });
        },

        mapRecordWithTable() {
            const vm = this;

            // Define the columns array dynamically based on the isReadOnly flag
            const columns = [
                {
                    title: 'Community',
                    data: 'community'
                },
                {
                    title: 'City',
                    data: 'city'
                },
                {
                    title: 'State',
                    data: 'state'
                },
                {
                    title: 'Country',
                    data: 'country'
                },
                {
                    title: 'Location',
                    data: 'lat_lng',
                    render: function (data, type) {
                        if (data) {
                            return `<a href="https://www.google.com/maps/search/?api=1&query=${data}" target="_blank">Map <i class="fa fa-external-link"></i> </a>`
                        } else {
                            return 'N/A';
                        }
                    }
                },
                {
                    title: 'Action',
                    data: null,
                    render: function (data, type, row) {
                        if (vm.isReadOnly) {
                            return `<button type="button" class="btn btn-warning viewHcCommunity" data-data="${encodeURIComponent(JSON.stringify(data))}">View</button>`;
                        }
                        return `<button type="button" class="btn btn-warning viewHcCommunity" data-data="${encodeURIComponent(JSON.stringify(data))}">View/Edit</button>`;
                    }
                }
            ]

            $("#hcCommunityRecords").DataTable({
                search: {
                    caseInsensitive: false
                },
                data: vm.records,
                destroy: true,
                dom: 'lBfrtip',
                "bInfo": false,
                "scrollX": true,
                language: {
                    emptyTable: "No records available",
                },
                columns: columns, // Use the dynamically defined columns
                buttons: [
                    {
                        extend: 'excelHtml5',
                        text: 'Export to excel',
                        className: 'btn btn-default',
                        exportOptions: {
                            columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
                            orthogonal: 'export'
                        },
                    },
                    {
                        extend: 'colvis',
                        text: 'Filter Columns',
                        className: 'btn btn-default'
                    }
                ],
                'fnRowCallback': function (nRow) {
                    const viewEditBtn = $('.viewHcCommunity', nRow);
                    vm.editCommunityDialog(viewEditBtn);
                    return nRow;
                }
            })
        },
        editCommunityDialog(editEl) {
            let vm = this;
            vm.isLocationConfirmed = true;
            editEl[0].addEventListener('click', function () {
                let record = JSON.parse(decodeURIComponent(this.getAttribute("data-data")));
                vm.model.selectedCountry = record.country;
                vm.model.selectedState = record.state;
                vm.model.selectedLocality = record.city;
                vm.model.selectedLocation = record.lat_lng;
                vm.model.community = record.community;
                vm.model.communityId = record.id;
                vm.showAddCommunityDialog();
            }, false);
        },

        saveCommunity() {
            const vm = this;
            if (vm.model.communityId) {
                vm.updateCommunity();
            } else {
                vm.addCommunity();
            }       
        },

        updateCommunity() {
            const vm = this;
            const payload = {
                lat_lng: vm.model.selectedLocation,
                country: vm.model.selectedCountry,
                state: vm.model.selectedState,
                city: vm.model.selectedLocality,
                community: vm.model.community
            };
            vm.show.actionLoading = true;
            communityService.updateCommunity(vm.projectId, vm.model.communityId, payload)
            .then((apiResponse) => {
                apiResponse = apiResponse.response;
                vm.show.actionLoading = false;
                if (!apiResponse.error.error_code) {
                    vm.dialogVisible = false;
                    vm.showAlert('Success', `Community ${vm.model.community} updated`, true);
                    vm.getCommunityList();
                    vm.resetModel();
                } else {
                    vm.showAlert('Error', apiResponse.error.msg, false);
                }
            })
            .catch((error) => {
                vm.show.actionLoading = false;
                vm.showAlert('Error', error.response.error.error_msg, false);
            })
        },

        resetModel() {
            vm.model = {
                selectedCountry: null,
                selectedState: null,
                selectedLocality: null,
                selectedLocation: null,
                community: null,
                communityId: null
            }
        },
        async fetchLocality() {
            const vm = this;
            try {
                vm.fetchingAddress = true;
                const latlng = this.model.selectedLocation.split(',');
                const address = await ReverseGeocodingService.getAddress(latlng);

                vm.model.selectedCountry = address.country;
                vm.model.selectedState = address.state;
                vm.model.selectedLocality = address.locality;
            }catch(error){
                console.log(error);
            } finally {
                vm.fetchingAddress = false;
                vm.selectCountryLabel = 'Country';
                vm.selectStateLabel = 'State';
                vm.selectLocalityLabel = 'Locality';
            }
        },
        updateDialogSize() {
            const w = window.innerWidth;
            if (w <= 600) {
                this.isMobile = true;
                this.dialogWidth = '100%';
            } else if (w <= 992) {
                this.isMobile = false;
                this.dialogWidth = '80%';
            } else {
                this.isMobile = false;
                this.dialogWidth = '60%';
            }
        }


    },
    mounted() {
        let vm = this;
        vm.project = vm.$store.getters.getCurrentSelectedProject;
        vm.isReadOnly = false
        vm.$store.getters.getUserRoleForCurrentProject.forEach(r => {
            if (r.role_name == 'VIEWER') {
                vm.isReadOnly = true
            }
        });
        vm.getCommunityList();
        vm.mapRecordWithTable();
        vm.updateMapCenterAndMarker();
        this.updateDialogSize();
        window.addEventListener('resize', this.updateDialogSize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateDialogSize);
    } 
}

</script>
<style scoped>

@media (max-width: 992px) {

  .responsive-dialog {
    width: 80% !important;
  }
}

@media (max-width: 600px) {
  .responsive-dialog {
    width: 90% !important;
  }
}
.pac-card {
    margin: 10px 10px 0 0;
    border-radius: 2px 0 0 2px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    outline: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    background-color: #fff;
    font-family: "Noto Sans";
}

.set_font_title {
    font-size: 20px;
    font-weight: 600;
    color: black;
}

</style>